module.exports = __webpack_public_path__ + "static/media/9DESA33.b902ef24.jpg";